function LoadingPlaceholder({ className = "" }) {
  return <div className={`animate-pulse rounded-md bg-cyan-300/10 ${className}`} aria-hidden="true" />;
}

export function LoadingCard({ imageHeight = "h-48" }) {
  return (
    <article className="card overflow-hidden">
      <LoadingPlaceholder className={`${imageHeight} w-full rounded-none`} />
      <div className="p-5">
        <LoadingPlaceholder className="h-5 w-3/4" />
        <LoadingPlaceholder className="mt-3 h-4 w-1/2" />
      </div>
    </article>
  );
}

export function LoadingTableRows({ rows = 4, columns = 3 }) {
  return Array.from({ length: rows }).map((_, rowIndex) => (
    <tr key={`loading-row-${rowIndex}`}>
      {Array.from({ length: columns }).map((__, columnIndex) => (
        <td key={`loading-cell-${rowIndex}-${columnIndex}`} className="px-5 py-4">
          <LoadingPlaceholder className={`h-4 ${columnIndex === 0 ? "w-44" : "w-28"}`} />
        </td>
      ))}
    </tr>
  ));
}

export default LoadingPlaceholder;
